import axios from 'axios'
import {API_URL} from '../../../tenant/apiBase'
// Remove ITotalInTransitBody import as it's not used for this response structure
import { IActiveProductsBody, IBestSellerProductsModel, IDailySalesDataBody, IMonthlyServiceBody, INextPaymentBody,
  IPendingPOSModel, ISalesDataBody, IStockQtyBody, ITransactionSummaryBody } from './_models'
// Remove unused imports from reports if ITotalInTransitRow is no longer needed here
// import {IInTransitReportModel, ITotalInTransitRow} from "../../reports/core/_models";
// import {GET_IN_TRANSIT_SALES_REPORT} from "../../reports/core/_requests";

export const GET_SALES_DATA = `${API_URL}/api/partner-portal/dashboard/sales`
export const GET_DAILY_SALES = `${API_URL}/api/partner-portal/dashboard/total-daily-sales`
export const GET_ACTIVE_PRODUCTS_INFO = `${API_URL}/api/partner-portal/dashboard/active-products-count`
export const GET_STOCK_QTY_INFO = `${API_URL}/api/partner-portal/dashboard/stock-qty`
export const GET_MONTHLY_SERVICE_INFO = `${API_URL}/api/partner-portal/dashboard/monthly-service-level`
export const GET_NEXT_PAYMENT_INFO = `${API_URL}/api/partner-portal/dashboard/next-payment`
export const GET_BEST_SELLER_PRODUCTS_INFO = `${API_URL}/api/partner-portal/dashboard/best-seller-products`
export const GET_PENDING_POS_INFO = `${API_URL}/api/partner-portal/dashboard/pending-pos`
export const GET_TOTAL_IN_TRANSIT_PRODUCT = `${API_URL}/api/partner-portal/dashboard/total-in-transit-products`
export const GET_TRANSACTION_SUMMARY = `${API_URL}/api/partner-portal/dashboard/current-month-transaction-total` // Added endpoint

export function getSalesData(token:string|undefined,language:string) {
  return axios.get<{data: ISalesDataBody}>(`${GET_SALES_DATA}`, {
    headers: {token: token || "", language},
  })
}

// Define the correct response type for Daily Sales including the info field
type DailySalesResponse = {
  data: IDailySalesDataBody;
  info: string;
}

export function getDailySales(token:string|undefined,language:string) {
  return axios.get<DailySalesResponse>(`${GET_DAILY_SALES}`, { // Use the updated type
    headers: {token: token || "", language},
  })
}

export function getActiveProductsInfo(token:string|undefined,language:string) {
  return axios.get<{data: IActiveProductsBody; active_products_info?: string}>(`${GET_ACTIVE_PRODUCTS_INFO}`, {
    headers: {token: token || "", language},
  })
}
export function getStockQtyInfo(token:string|undefined,language:string) {
  return axios.get<{data: IStockQtyBody}>(`${GET_STOCK_QTY_INFO}`, {
    headers: {token: token || "", language},
  })
}

export function getMonthlyServiceInfo(token:string|undefined,language:string) {
  return axios.get<{data:IMonthlyServiceBody}>(`${GET_MONTHLY_SERVICE_INFO}`, {
    headers: {token: token || "", language},
  })
}

export function getNextPaymentInfo(token:string|undefined,language:string) {
  return axios.get<{next_payment:INextPaymentBody}>(`${GET_NEXT_PAYMENT_INFO}`, {
    headers: {token: token || "", language},
  })
}


export function getBestSellerProductsInfo(token:string|undefined,language:string) {
  return axios.get<{data:{best_seller_products:IBestSellerProductsModel[]}}>(`${GET_BEST_SELLER_PRODUCTS_INFO}?language=${language}`, {
    headers: {token: token || "", language},
  })
}


export function getPendingPOSInfo(token:string|undefined,language:string,limit=5) {
  return axios.get<{data:{pending_pos:IPendingPOSModel[],pending_pos_count:number}}>(`${GET_PENDING_POS_INFO}?limit=${limit}`, {
    headers: {token: token || "", language},
  })
}



export function getInTransitReports(
    token: string | undefined,
    language: string
) {
  // Define the correct response structure inline
  return axios.get<{
    total_in_transit: { total_quantity: string; total_sale_price: string; }; // Nested object
    info: string; // Top-level info field
   }>(
      `${GET_TOTAL_IN_TRANSIT_PRODUCT}`,
      {
        headers: {
          token: token || '',
          language: language,
        },
      }
  );
}

export function getTransactionSummary(token:string|undefined,language:string) {
  return axios.get<{data: ITransactionSummaryBody}>(`${GET_TRANSACTION_SUMMARY}`, { // Added function
    headers: {token: token || "", language},
  })
}
